import { CALL_API } from './../../middlewares/api';

const onSaveRelato = (value) => ({
  [CALL_API]: {
    type: 'SAVE_RELATO_PROBLEMA',
    endpoint: 'problema',
    authenticated: true,
    config: {
      method: 'POST',
      querystring: { simples: 0 },
      body: value
    }
  }
});

const onExecutaAcaoSimplificada = (value) => ({
  [CALL_API]: {
    type: 'EXECUTA_ACAO_SIMPLIFICADA',
    endpoint: 'acao-simplificada',
    authenticated: true,
    config: {
      method: 'POST',
//      redirect: 'manual',
      body: value
    },
    success: result => {
      let location = result.response.headers.get('Location');
      if (location) {
        result.json['location'] = location;
      }
      return result.json;
    }
  }
});

const onLoadLocais = () => ({
  [CALL_API]: {
    type: "LIST_LOCAIS_PROBLEMA",
    endpoint: 'problema',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: "locais" }
    }
  }
});

const onLoadMeusRegistros = () => ({
  [CALL_API]: {
    type: "LIST_MEUS_REGISTROS_PROBLEMA",
    endpoint: 'problema',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: "meus-registros" }
    }
  }
});

const onChangeListProblema = status => dispatch => ({ value }) => 
dispatch({});

const onLoadCategorias = () => ({
  [CALL_API]: {
    type: "LIST_CATEGORIAS_PROBLEMA",
    endpoint: 'problema',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: "categorias" }
    }
  }
});

export default {
  onSaveRelato,
  onLoadLocais,
  onLoadCategorias,
  onLoadMeusRegistros,
  onChangeListProblema,
  onExecutaAcaoSimplificada
};


// WEBPACK FOOTER //
// ./src/modules/problema/actions.js